import { render, staticRenderFns } from "./NewEditAlunoPage.vue?vue&type=template&id=2eb47e26"
import script from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAlunoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports